// extracted by mini-css-extract-plugin
export default {"tupacGrid":"wp-z","tupacHeader":"xp-z","tupacHeader2":"yp-z","tupacMenu":"zp-z","tupacMenu2":"Ap-z","tupacMain":"Bp-z","tupacMain2":"Cp-z"};